import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import singleImage from '../../../images/singleblog.svg';
import CustomCarousel from '../../../components/carousel';
import Blogcard from '../../../components/blogcard';
import blogImage from '../../../images/blogg.svg';

function SingleBlogBody() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [relatedBlogs, setRelatedBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogDetails = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BLOG_BASE_URL}/get_blog_details.php?id=${id}`);
                if (response.data.code === 200) {
                    setBlog(response.data.blog);
                } else {
                    setError('Failed to load blog details');
                }
            } catch (err) {
                console.error('Error fetching blog details:', err);
                setError('Error loading blog details.');
            } finally {
                setLoading(false);
            }
        };

        fetchBlogDetails();
    }, [id]);

    return (
        <div className='px-10 lg:px-20 lg:py-10'>
            {loading ? (
                <p className="text-center text-gray-500">Loading blog...</p>
            ) : error ? (
                <p className="text-center text-red-500">{error}</p>
            ) : (
                <>
                    <div className=''>
                        <img className='h-[590px]' src={blog.image_path ? process.env.REACT_APP_BLOG_BASE_URL+'/'+blog.image_path : singleImage} alt={blog.title} />
                    </div>
                    <div className='mt-2 text-[#5E5E5E] text-[20px] font-[400] text-start'>
                        Published {new Date(blog.created_at).toLocaleDateString()}
                    </div>
                    <div className='flex flex-col space-y-3 text-start mt-3 lg:mt-8'>
                        <div className='text-[30px] lg:text-[48px] font-[600] text-[#0E0E0E] leading-[40px] lg:leading-[67.2px]'>
                            {blog.title}
                        </div>
                        <div className='text-[#4F4F4F] text-[18px] font-[400]'>
                            {blog.details}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default SingleBlogBody;